module.exports = __webpack_public_path__ + "img/h.dc8a5da0.svg";